const SaveIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <path
        d="M64.793,63.156a1.636,1.636,0,0,0-1.637,1.637V79.52a1.635,1.635,0,0,0,1.637,1.636H79.52a1.635,1.635,0,0,0,1.636-1.636V66.429l-3.273-3.273H76.247v4.909a.82.82,0,0,1-.818.818H68.065a.82.82,0,0,1-.818-.818V63.156Zm8.182,0v4.091h1.636V63.156Zm-4.909,9.818h8.182a1.635,1.635,0,0,1,1.636,1.636V79.52H66.429V74.611A1.635,1.635,0,0,1,68.065,72.975Z"
        transform="translate(-63.156 -63.156)"
      />
    </svg>
  );
};

export default SaveIcon;
